export default "__VITE_ASSET__6s52Nwi___"